import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';
import { AzurePostgreSqlTableDataset } from 'app/model/dataset/azure-postgre-sql-table.dataset';
import {
    tabularPropertiesCommonAdapts,
    TabularTypeDatasetAdapter,
} from './tabular-type.dataset.adapter';
import { ValueAdapter } from '../value.adapter';
import { GlobalVariables } from 'app/services/globals';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AzurePostgreSqlTableDataset),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            ...tabularPropertiesCommonAdapts,
            version: __IS_FABRIC_DPE__ ? '*' : undefined,
            typeProperties: {
                tableName: '*',
                schema: '*',
                table: '*'
            },
            connectionProperties: GlobalVariables.connectionPropertiesForPostgreSql ? '*' : undefined
        }
    }
})
export class AzurePostgreSqlDatasetAdapter extends TabularTypeDatasetAdapter<
    AzurePostgreSqlTableDataset,
    Model.DatasetResource
> {
    protected async _toResource(dataset: AzurePostgreSqlTableDataset): Promise<Model.DatasetResource> {
        const datasetResource = await this._toResourceInternal(
            dataset,
            Metamodel.modelFor(AzurePostgreSqlTableDataset).name
        );
        if (__IS_FABRIC_DPE__) {
            datasetResource.properties.version = ValueAdapter.toResource(dataset, AzurePostgreSqlTableDataset.VERSION);
        }
        return datasetResource;
    }

    protected async _toModel(
        modelDatasetResource: Model.DatasetResource,
        dataset?: AzurePostgreSqlTableDataset
    ): Promise<AzurePostgreSqlTableDataset> {
        const modelDataset = await this._toModelInternal(
            modelDatasetResource,
            dataset,
            AzurePostgreSqlTableDataset.MODEL
        );
        if (__IS_FABRIC_DPE__) {
            modelDataset.version = undefined;
            ValueAdapter.toModel(
                modelDataset,
                AzurePostgreSqlTableDataset.VERSION,
                modelDatasetResource.properties.version
            );
        }
        return modelDataset;
    }
}
